module.exports = __webpack_public_path__ + "static/img/case2.e2e57ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/case2.png
// module id = aLc0
// module chunks = 1